import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const notifications = [
  { value: 'referral_team_created', text: 't(a new referral signs up through my affiliate singup page)' },
  { value: 'referral_trial_started', text: 't(a referral is set up and beings their free trial)' },
  { value: 'referral_trial_ended', text: 't(a referral completes their free trial and is charged for their first month)' },
  { value: 'referral_subscription_canceled', text: 't(a referral cancels their subscription)' },
  { value: 'payout_issued', text: 't(a new commission payout is issued)' }
]

const getIcon = (value, notification) => ({
  svg: value[notification] ? 'check' : 'x'
})

const AffiliateNotificationsToken = ({ value }) => (
  <div className="maha-affiliate-notifications-token">
    <table>
      <tbody>
        { notifications.map((notification, index) => (
          <tr key={`day_${index}`}>
            <td><T text={ notification.text } /></td>
            <td><Icon { ...getIcon(value, notification.value) } /></td>
          </tr>
        )) }
      </tbody>
    </table>
    
  </div>
)

AffiliateNotificationsToken.propTypes = {
  value: PropTypes.object
}

export default AffiliateNotificationsToken
